// extracted by mini-css-extract-plugin
module.exports = {"pageNumbers":"paginated_pageNumbers__1KxhG","active":"paginated_active__2EAPd","buttPaginated":"paginated_buttPaginated__zZ-yk"};